/**
 * Helper to yield to main and schedule heavy work into another task, useful for
 * breaking up interactions, you still want to present something to the user ASAP
 * and then call this.
 *
 * https://web.dev/optimize-inp/#yield-to-allow-rendering-work-to-occur-sooner
 *
 * @param callback
 */ export function yieldToMain(callback) {
    requestAnimationFrame(()=>{
        setTimeout(callback, 0);
    });
}
/**
 * Same as above but can be used within an async
 *
 * https://web.dev/optimize-long-tasks/#use-asyncawait-to-create-yield-points
 *
 * @returns
 */ export function yieldToMainAsync() {
    return new Promise((resolve)=>{
        setTimeout(resolve, 0);
    });
}

//# sourceMappingURL=yieldToMain.js.map